export default __webpack_public_path__ + "static/media/D2.69e54566.jpg";